import { Value, ValueIface } from './Value';

export interface LookupStoreIface<V> {
  [id: string]: V;
}

export function LookupStoreValue<V>(): ValueIface<LookupStoreIface<V>> {
  return Value<LookupStoreIface<V>>({});
}
